/**
 * Shared utilities for the GestionContable module.
 */

/**
 * Converts a value to a finite number, or 0 if not possible.
 */
export const toNum = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Returns the current period in YYYY-MM format.
 */
export const periodoActual = () => new Date().toISOString().slice(0, 7);

/**
 * Returns the period prior to the given one in YYYY-MM format.
 */
export const periodoAnterior = (periodo) => {
  const reference = periodo || periodoActual();
  const [y, m] = reference.split("-").map(Number);
  const d = new Date(y, (m || 1) - 2, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

/**
 * Standardizes user identifier for audit logs.
 */
export const getUsuarioId = (usuario) => {
  return usuario?.correo || usuario?.email || usuario?.usuario || "SISTEMA";
};

/**
 * Formats a number as a currency string.
 */
export const formatCurrency = (amount, currency = "PEN") => {
  const symbol = currency === "USD" ? "$" : "S/";
  return `${symbol} ${toNum(amount).toFixed(2)}`;
};

/**
 * Formats a date string to a more readable format (YYYY-MM-DD).
 */
export const formatDate = (dateString) => {
  if (!dateString) return "-";
  return dateString.slice(0, 10);
};

/**
 * Validates a RUC number (11 digits).
 */
export const isValidRuc = (ruc) => {
  return /^\d{11}$/.test(String(ruc).trim());
};

/**
 * Simple confirmation dialog using browser native confirm.
 */
export const promptConfirm = (message) => {
  return window.confirm(message);
};
